var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-block"},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.language,"value-field":"value","text-field":"description"},on:{"change":function($event){return _vm.editLang()}},model:{value:(_vm.currentLang),callback:function ($$v) {_vm.currentLang=$$v},expression:"currentLang"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }